import authHeader from 'srcReact/helpers/auth-header'
import { isEmpty } from 'srcReact/helpers/validator'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'

export const subscriptionService = {
  getSubscriptionHostedUrl,
  createAfterCheckout,
  updateAfterCheckout,
  getSubscription,
  getManagePaymentUrl,
  cancel,
  getPlanUpdateList,
  updatePlan,
  cancelPendingPlanUpdate,
  getCurrency
}

function getSubscriptionHostedUrl(organizationId, planId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return doRequestAxios(`/subscription-hosted-url?organization_id=${organizationId}&plan_id=${planId}`, requestOptions)
}

function createAfterCheckout(organizationId, hostedPageId, state) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: {
      organization_id: organizationId,
      hosted_page_id: hostedPageId,
      state: state,
    }
  }
  return doRequestAxios(`/subscription-after-checkout`, requestOptions)
}

function updateAfterCheckout(organizationId, hostedPageId, state, subscriptionId, new_plan) {
  let data = {
    organization_id: organizationId,
    state,
    new_plan,
  }
  if (!isEmpty(hostedPageId)) {
    data.hosted_page_id = hostedPageId
  } else if (!isEmpty(subscriptionId)) {
    data.subscription_id = subscriptionId
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: data
  }
  return doRequestAxios(`/subscription-after-checkout`, requestOptions)
}

function getSubscription(organizationId, fromChargebee) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return doRequestAxios(`/subscription?organization_id=${organizationId}&from_chargebee=${fromChargebee}`, requestOptions)
}

function getManagePaymentUrl(organizationId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return doRequestAxios(`/subscription-payment-hosted-url?organization_id=${organizationId}`, requestOptions)
}

function getPlanUpdateList(organizationId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return doRequestAxios(`/subscription/plan-update-list?organization_id=${organizationId}`, requestOptions)
}

function cancel(organizationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
  }
  return doRequestAxios(`/subscription/cancel?organization_id=${organizationId}`, requestOptions)
}

function updatePlan(organizationId, planId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: {
      organization_id: organizationId,
      plan_id: planId,
    },
  }
  return doRequestAxios(`/subscription/plan-update`, requestOptions)
}

function cancelPendingPlanUpdate(organizationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      organization_id: organizationId,
    },
  }
  return doRequestAxios(`/subscription/pending-plan-update-cancel`, requestOptions)
}

function getCurrency(organizationId, longitude, latitude, language) {
  const is_logged = isUserAuthorized() ? 1 : 0
  const requestOptions = {
    method: 'GET',
    headers: authHeader(is_logged)
  }
  return doRequestAxios(`/v2/subscription/get-front-currency/${is_logged}?organization_id=${organizationId}&longitude=${longitude}&latitude=${latitude}&language=${language}`, requestOptions)
}